module.exports = __webpack_public_path__ + "imgs/top-gradient.61d732130688c403b222c355e912a8b3.svg";